import FetchData from '../Components/ServerCall/FetchData';
import { contentTypes } from '../Components/CommonFunctions/aliases';
import Cookies from 'js-cookie';

/**
 * Get privilege for playbook given workspaceId, contentTypeId and contentId
 */
export const getPrivilegeForPlayBook = async (
  token: string,
  workspaceId: string,
  contentId: string,
): Promise<any> => {
  return FetchData({
    requestType: 'noData',
    method: 'GET',
    url: `privilege?workspaceId=${workspaceId}&contentTypeId=${contentTypes.Playbook}&contentId=${contentId}`,
    headers: { Authorization: `Bearer ${token}` },
  });
};

/**
 * Get all subworkspaces tree
 */
export const getAllSubWorkspaces = async (token: string): Promise<any> => {
  return FetchData({
    requestType: 'noData',
    method: 'GET',
    url: `workspaces/tree`,
    headers: { Authorization: `Bearer ${token}` },
  });
};

/**
 * Update existing playbook by ID
 */
export const updatePlaybook = async ({
  playBookObj,
  playBookUid,
  workspaceId,
}: {
  playBookUid: string;
  workspaceId: string;
  playBookObj: any;
}) => {
  try {
    const response = await FetchData({
      requestType: 'withData',
      method: 'PUT',
      url: `playbook/${playBookUid}?workspaceId=${workspaceId}`,
      data: playBookObj,
      headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
    });

    if (!response.status) {
      return { isError: true, message: 'Failed to update playbook', data: null };
    }

    return { isError: false, message: 'Playbook updated successfully', data: response.data };
  } catch (error) {
    return { isError: true, message: 'Unexpected error during update', data: null };
  }
};

/**
 * Save new playbook
 */
export const savePlaybookApi = async (
  token: string,
  workspaceId: string,
  playBookObj: any,
): Promise<any> => {
  return FetchData({
    requestType: 'withData',
    method: 'POST',
    url: `playbook?workspaceId=${workspaceId}`,
    data: playBookObj,
    headers: { Authorization: `Bearer ${token}` },
  });
};
